import React from 'react';
import styled from 'styled-components';
import { RowDiv } from 'styles';
import { Icon } from './Icon';

export function Pagination({ paginationRequest, paginationResult, setPaginationRequest, ...props }) {
  const changePage = (i) => {
    setPaginationRequest({
      pageNumber: i,
      pageSize: paginationRequest.pageSize
    });
  };
  const pageNum = () => {
    const forArray = [];

    for (let i = 1; i <= paginationResult.totalPages; i += 1) {
      forArray.push(
        <Button
          key={i}
          $active={i === paginationResult.page}
          onClick={() => {
            changePage(i);
          }}
        >
          {i}
        </Button>,
      );
    }

    return forArray;
  };
  return (
    (paginationResult && paginationResult.total > 0 && (
      <Container {...props}>
        <Icon
          className="pagination-button prev"
          name="arrow"
          onClick={() => {
            if (paginationResult.page > 1) {
              changePage(paginationResult.page - 1)
            }
          }}
        />
        {pageNum()}
        <Icon
          className="pagination-button next"
          name="arrow"
          onClick={() => {
            if (paginationResult.page < paginationResult.totalPages) {
              changePage(paginationResult.page + 1)
            }
          }}
        />
      </Container>
    )) || <></>
  );
}

const Container = styled(RowDiv)`
  gap: 16px;
  align-items: center;
  justify-content: center;
  text-align: center;

  & > .pagination-button {
    border-radius: 6px;
    cursor: pointer;
    transition: 0.1s ease-in;

    &:hover {
      opacity: 0.5;
    }

    &:active {
      background-color: ${({ theme }) => theme.colors.primary};
      & > svg {
        fill: white;
      }
    }
  }

  & > .prev {
    transform: rotate(90deg);
  }

  & > .next {
    transform: rotate(-90deg);
  }
`;

const Button = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 2px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  color: ${({ theme }) => theme.colors.dark};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary900};
    color: white;
  }

  ${({ $active, theme }) =>
    $active &&
    `
  background-color: ${theme.colors.primary900};
  color: white;
  font-weight: 700;
`}
`;
